import API from "../utils/api";

export const ACTION_TYPES = {
    ROOM_CREATE: 'ROOM_CREATE',
    ROOM_UPDATE: 'ROOM_UPDATE',
    ROOM_DELETE: 'ROOM_DELETE',
    ROOM_FETCH: 'ROOM_FETCH',
    ROOM_FETCH_ALL: 'ROOM_FETCH_ALL',
    ROOM_PAGINATION: 'ROOM_PAGINATION',
    VCROOM_UPDATE: 'VCROOM_UPDATE',
    ROOM_FETCH_UNREAD_COUNT: 'ROOM_FETCH_UNREAD_COUNT',
    ROOM_UPDATE_COUNT: 'ROOM_UPDATE_COUNT',
    ROOM_UPDATE_COUNT_ONLY_RESET: 'ROOM_UPDATE_COUNT_ONLY_RESET',
    ROOM_UPDATE_NO: 'ROOM_UPDATE_NO'
}

export const fetchAll = (input) => dispatch => {
    API.room().fetchAll(input)
        .then(res => {
            dispatch({
                type: ACTION_TYPES.ROOM_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}
export const getUnreadCount = () => dispatch => {
    API.room().getUnreadCount()
        .then(res => {
           console.log('getUnreadCount',res.data)
            dispatch({
                type: ACTION_TYPES.ROOM_FETCH_UNREAD_COUNT,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, userid = "", searchstring = "", params ="", onSuccess) => dispatch => {
    //console.log('rooms',business_mobile, customer)
    API.room().fetchPagination(page, Math.abs(limit), userid, searchstring, params)
        .then(res => {
                       console.log('rooms==',res.data)

            dispatch({
                type: ACTION_TYPES.ROOM_PAGINATION,
                payload: res.data
            })
            if (onSuccess){onSuccess(res.data)}
        })
        .catch(err => console.log(err))
}

export const findPaginationWithSearch = (page = 1, limit = 5, userid = "", searchstring = "", params ="") => dispatch => {
    //console.log('rooms',business_mobile, customer)
    API.room().findPaginationWithSearch(page, Math.abs(limit), userid, searchstring, params)
        .then(res => {
            console.log('res.data',res.data)
            dispatch({
                type: ACTION_TYPES.ROOM_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.room().fetchById(id)
        .then(res => {
            dispatch({
                type: ACTION_TYPES.ROOM_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.room().create(input)
        .then(res => {

            dispatch({
                type: ACTION_TYPES.ROOM_CREATE,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {

    API.room().update(id, input)
        .then(res => {
            dispatch({
                type: ACTION_TYPES.ROOM_UPDATE,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.room().delete(id)
        .then(res => {

            dispatch({
                type: ACTION_TYPES.ROOM_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const findidpdate = (id, input, onSuccess) => dispatch => {

    API.room().findidpdate(id, input)
        .then(res => {
            console.log('wee', res.data)
            dispatch({
                type: ACTION_TYPES.ROOM_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}